
import React from 'react';
import { Button,Modal, Tooltip } from "antd";

import './EachSyncReport.scss';

const EachSyncReport = (props) => {
    return (
        <div>
            <ul>
                <li>{props.id}</li>
                <li>{props.source}</li>
                <li>{props.destination}</li>
                <li>{props.syncFrequency}</li>
                <li>{props.date}</li>
                <li>
                  <Tooltip title="Trigger Now">
                    <Button
                      className="replication-upload-btn"
                      icon="upload"
                      onClick={e =>
                          showTriggerConfirm(e, props.handleTriggerClick, props.id, (props.source + " > " + props.destination))
                        }
                    />
                  </Tooltip>
                  <Tooltip title="Delete">
                    <Button
                      className="replication-delete-btn"
                      icon="delete"
                      onClick={e =>
                          showDeleteConfirm(e, props.handleDeleteClick, props.id, (props.source + " > " + props.destination))
                        }
                    />
                  </Tooltip>

                </li>
            </ul>
        </div>
    )
}

const showDeleteConfirm = (
    e,
    handleDeleteClick,
    syncId,
    destination
  ) => {
    e.stopPropagation()
    Modal.confirm({
      title: `Do you want to remove the ${destination} Sync Information?`,
      content:
        "This will only remove your Sync Information from CloudFlyer.",
      onOk() {
        handleDeleteClick(syncId)
      }
    })
  }
  

  const showTriggerConfirm = (
    e,
    handleTriggerClick,
    syncId,
    destination
  ) => {
    e.stopPropagation()
    Modal.confirm({
      title: `Do you want to trigger the ${destination} Sync?`,
      content:
        "This will run the sync now.",
      onOk() {
        handleTriggerClick(syncId)
      }
    })
  }  

export default EachSyncReport;